import { AxiosError } from 'axios'

import { Toast } from 'vant'
import {
  AxiosReqResult,
  AxiosResResult,
  HttpHandler,
  HttpInterceptorInstance,
  Interceptor
} from './http'
import { reportUrl } from './reportSentry'

class BaseHttp extends HttpInterceptorInstance {
  public req(req: any, next: HttpHandler): AxiosReqResult {
    return next.reqHandle(req)
  }
  public res(res: any, next: HttpHandler): AxiosResResult {
    if(res && res.config && res.config.url) {
      reportUrl(res)
    }
   
    if (res && res.data) {
      res = res.data
    }
    return next.resHandle(res)
  }
  public error(error: AxiosError, next: HttpHandler): AxiosError {
    if (error.isAxiosError) {
      reportUrl(error.response, true)
    }
    return next.errorHandle(error)
  }
}

const baseHttp = new BaseHttp()

export const http = Interceptor()(baseHttp)

class EventHttp extends HttpInterceptorInstance {
  public lock = false
  public req(req: any, next: HttpHandler): AxiosReqResult {
    if (this.lock) {
      return
    } else {
      this.lock = true
      return next.reqHandle(req)
    }
  }
  public res(res: any, next: HttpHandler): AxiosResResult {
    this.lock = false
    return next.resHandle(res)
  }
}
const eventHttp = new EventHttp()
/**
 * 防止连续多次点击,多次请求接口现象
 */
export const eHttp = Interceptor()(eventHttp, baseHttp)

/**
 * loading
 */

class LoadingHttp extends HttpInterceptorInstance {
  public toast: any
  public requestNum = 0 //请求数
  public req(req: any, next: HttpHandler): AxiosReqResult {
    this.toast = Toast.loading({
      forbidClick: true,
      duration: 0
    })
    ++this.requestNum
    return next.reqHandle(req)
  }
  public res(res: any, next: HttpHandler): AxiosResResult {
    --this.requestNum
    if (this.toast && this.requestNum === 0) {
      this.toast.clear()
    }
    return next.resHandle(res)
  }
  public error(error: AxiosError, next: HttpHandler): AxiosError {
    --this.requestNum
    if (this.toast && this.requestNum === 0) {
      this.toast.clear()
    }
    return next.errorHandle(error)
  }
}

const loadingHttp = new LoadingHttp()
/**
 * loading状态并且不可点击
 */
export const lHttp = Interceptor()(loadingHttp, baseHttp)

/**
 * 没有任务拦截器
 */
export const ajax = Interceptor()()